
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/[collection]",
      function () {
        return require("private-next-pages/shop/[collection].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/[collection]"])
      });
    }
  